import React from 'react';
import {
  addPathToList,
  confirm_participants, getSubCategoryId, select_recipient, where_customer_review_participants,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================

const Panel_G02_SplitPaymentConfirmParticipant = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'amount_participant_title',
    'total_payment',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={select_recipient}
      panelSubHeadline={confirm_participants}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/recipient/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/recipient/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={where_customer_review_participants}
      language={language}
      paragraphMarginBottom={30}
    />
  );
};

export default Panel_G02_SplitPaymentConfirmParticipant;
